import React from "react"
import { NavLink } from 'react-router-dom'
import Loader from '../helpers/Loader'
import {getCsrf} from "../helpers/CsrfTags"
import Modal from 'react-bootstrap/Modal'
import Grouping from "./Grouping"
import { AppContext } from "../core/AppContext"

export default class RoundSetting extends React.Component {

  state = {
    loading:true,
    round_setting:false,
    showModal:false,
    confirmationType:false,
    grouping_rounds:[],
    creatingGroups:false,
    saving:false,
    playerSearch:'',
    searchResults:[],
    searching:false,
    managingPlayers:false
  }

  get basePath() {
    return `/round_settings/${this.props.match.params.id}`;
  }

  componentDidMount(){
    this.loadRoundSetting();
  }

  loadRoundSetting = () =>{
    fetch(`${this.basePath}.json`).then(response => response.json()).then(data => this.setState({round_setting:data,loading:false}));
  }

  updateRoundOnGrouping = (e,round) => {

    let {grouping_rounds} = this.state;
    let checked = e.target.checked;
    
    if (checked) {
      if (!grouping_rounds.some((r) => r.round_id == round.id))
        grouping_rounds.push({round_id:round.id,player:round.player})
    }
    else grouping_rounds = grouping_rounds.filter((r) => r.round_id != round.id );

    this.setState({grouping_rounds:grouping_rounds});

  }

  saveGroupings = () => {
    
    let {round_setting,grouping_rounds} = this.state;
    
    this.setState({saving:true});

    fetch(`${this.basePath}/groupings.json`, {
      method: 'post',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': getCsrf()
      },
      body: JSON.stringify({grouping:{round_setting_id:round_setting.id,grouping_rounds_attributes:grouping_rounds,showModal:false}})
    }).then(response =>  response.json()).then(data => this.setState({saving:false,creatingGroups:false,grouping_rounds:[]},this.loadRoundSetting));
  }

  randomizeGroupings = () => {
    this.setState({saving:true})
    fetch(`${this.basePath}/randomize_groupings.json`, {
      method: 'post',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': getCsrf()
      }
    }).then(response =>  response.json()).then(data => this.setState({round_setting:data,saving:false,showModal:false}));
  }

  standingsGroupings = () => {
    this.setState({saving:true})
    fetch(`${this.basePath}/standings_groupings.json`, {
      method: 'post',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': getCsrf()
      }
    }).then(response =>  response.json()).then(data => this.setState({round_setting:data,saving:false}));
  }

  searchPlayers = (q) => {
    this.setState({playerSearch:q});
    if (q.length < 2) { this.setState({searchResults:[]}); return; }
    this.setState({searching:true});
    fetch(`/users/following.json?q=${encodeURIComponent(q)}`).then(r => r.json()).then(data => {
      let existingPlayerIds = this.state.round_setting.rounds.map(r => r.player.id);
      this.setState({searchResults:data.filter(u => !existingPlayerIds.includes(u.id)),searching:false});
    });
  }

  addPlayer = (playerId) => {
    this.setState({saving:true});
    fetch(`${this.basePath}/add_player.json`, {
      method:'post',
      headers:{'Content-type':'application/json; charset=UTF-8','X-Requested-With':'XMLHttpRequest','X-CSRF-Token':getCsrf()},
      body:JSON.stringify({player_id:playerId})
    }).then(r => r.json()).then(data => {
      this.setState({saving:false,playerSearch:'',searchResults:[]},this.loadRoundSetting);
    });
  }

  removePlayer = (playerId) => {
    this.setState({saving:true});
    fetch(`${this.basePath}/remove_player.json`, {
      method:'delete',
      headers:{'Content-type':'application/json; charset=UTF-8','X-Requested-With':'XMLHttpRequest','X-CSRF-Token':getCsrf()},
      body:JSON.stringify({player_id:playerId})
    }).then(r => {
      if (!r.ok) return r.json().then(d => { alert(d.error); throw new Error(d.error); });
      return r.json();
    }).then(data => {
      this.setState({saving:false},this.loadRoundSetting);
    }).catch(() => this.setState({saving:false}));
  }

  render() {
    let {
      loading,
      round_setting,
      saving,
      creatingGroups,
      grouping_rounds,
      showModal,
      confirmationType,
      playerSearch,
      searchResults,
      searching,
      managingPlayers
    } = this.state;

    if (loading) return <Loader />;

    let grouping_round_ids = round_setting.groupings.map((g) => g.grouping_rounds_attributes.map((r) => r.round.id ).flat() ).flat();
    let available_rounds = round_setting.rounds.filter((r) => grouping_round_ids.indexOf(r.id) == -1 );

    return <AppContext.Consumer>{
      (context) => <div className="col-md-6 col-xl-11 mt-lg-3 px-0 align-self-start">
    <div className="card shadow flexbox-container rounded-0">
      <div className="card-header text-center">
          {round_setting.name || `Round Setting ${round_setting.id}`}
          {context.current_user.role.name == 'admin' && <NavLink to={`/round_settings/${round_setting.id}/games/new`} className="btn btn-sm btn-secondary shadow-sm top-right position-absolute ml-5" ><i className="fas fa-plus"></i> Gamble</NavLink>}
      </div>
      <div className="card-body pt-0 pb-5 px-0 px-lg-3">
        <div className="p-3">
          <label><strong>Groupings</strong></label> <br/>
          {
            round_setting.groupings.map((grouping) => <Grouping key={`grouping_${grouping.id}_${grouping.grouping_rounds_attributes.length}_rounds_${available_rounds.map(({id}) => id ).join('_')}`} editable={context.current_user.role.name == 'admin'} grouping={grouping} roundSettingId={this.props.match.params.id} availableRounds={available_rounds} afterUpdate={this.loadRoundSetting} />)
          }
          {context.current_user.role.name == 'admin' && <>
          <button className="btn btn-dark btn-block rounded-pill shadow-sm my-2" disabled={saving || creatingGroups} onClick={() => this.setState({showModal:true,confirmationType:'Randomize'})}>Random Groupings</button>
          <button className="btn btn-info btn-block rounded-pill shadow-sm my-2" disabled={saving || creatingGroups} onClick={() => this.setState({showModal:true,confirmationType:'Standingize'})}>Group by Standings</button>
          {(round_setting.groupings.map((g) => g.grouping_rounds_attributes.length ).reduce(function(a, b){ return a + b }, 0) < round_setting.rounds.length) && <button className={`btn btn-${creatingGroups ? 'danger' : 'secondary'} btn-block rounded-pill shadow-sm my-2`} disabled={saving} onClick={() => this.setState({creatingGroups:!creatingGroups})}>{creatingGroups ? 'Cancel New Grouping':'New Grouping'}</button>}
          
          <hr/>
          
          {creatingGroups && <button className="btn btn-sm btn-success pull-right rounded-pill shadow" disabled={saving || grouping_rounds.length == 0} onClick={this.saveGroupings} >Create Group</button>}
          
          <div className="d-flex justify-content-between align-items-center">
            <label className="mb-0"><strong>Players ({round_setting.rounds.length})</strong></label>
            <button className={`btn btn-sm btn-${managingPlayers ? 'danger' : 'outline-secondary'} rounded-pill`} onClick={() => this.setState({managingPlayers:!managingPlayers,playerSearch:'',searchResults:[]})}>
              {managingPlayers ? 'Done' : 'Manage Players'}
            </button>
          </div>
          <br/>

          {managingPlayers && <div className="mb-3">
            <input type="text" className="form-control rounded-pill mb-2" placeholder="Search players to add..." value={playerSearch} onChange={(e) => this.searchPlayers(e.target.value)} />
            {searching && <p className="text-muted text-center small">Searching...</p>}
            {searchResults.length > 0 && <ul className="list-group mb-2">
              {searchResults.map(user => <li key={user.id} className="list-group-item d-flex justify-content-between align-items-center">
                <span>{user.name} {user.handicap != null && <small className="text-muted">({user.handicap})</small>}</span>
                <button className="btn btn-sm btn-success rounded-pill" disabled={saving} onClick={() => this.addPlayer(user.id)}>Add</button>
              </li>)}
            </ul>}
            {playerSearch.length >= 2 && !searching && searchResults.length === 0 && <p className="text-muted text-center small">No players found</p>}
          </div>}

          {managingPlayers && <ul className="list-group mb-3">
            {round_setting.rounds.map((round) => <li key={round.id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong>{round.player.name}</strong>
                {round.final_score && <small className="text-muted ml-2">({round.final_score})</small>}
              </div>
              {!round["started?"] && <button className="btn btn-sm btn-outline-danger rounded-pill" disabled={saving} onClick={() => { if(confirm(`Remove ${round.player.name} from this round?`)) this.removePlayer(round.player.id) }}>Remove</button>}
              {round["started?"] && <span className="badge badge-secondary">In Progress</span>}
            </li>)}
          </ul>}

          {!managingPlayers && <>
          <label><strong>Available Players</strong></label> <br/>
          {
            available_rounds.length > 0 &&
            <ul className="list-group">
              {
                available_rounds.map((round) => <li className="list-group-item">
                {
                creatingGroups && <div className="custom-control custom-switch pull-left mr-2">
                    <input type="checkbox" className="custom-control-input" disabled={saving} id={`groupSwitchRound${round.id}`} onClick={(e) => this.updateRoundOnGrouping(e,round)} />
                    <label className="custom-control-label" for={`groupSwitchRound${round.id}`}></label>
                  </div>
                }
                <strong>{round.player.name}</strong>
                </li> )
              }
            </ul>
          }
          {
            available_rounds.length == 0 && <p className="text-info text-center">All players have been assigned a grouping</p>
          }
          </>}

          <hr/>

          <label><strong>Gambles</strong></label> <br/>

            {
              round_setting.games.length > 0 && <ul className="list-group">
                        {
                          round_setting.games.map((game) => {
                            return <NavLink to={`/round_settings/${round_setting.id}/games/${game.id}`} className="list-group-item" >{game.name}</NavLink>
                          })
                        }
                        </ul>
              }
          {
              !round_setting.games.length && <p className="text-info text-center">No gambles created for this round</p>
          }
          </>}
        </div>
      </div>
    </div>
    <Modal show={showModal} onHide={() => this.setState({showModal:false})}>
    <Modal.Header closeButton>
      <strong>Are you sure?</strong>
    </Modal.Header>
    <Modal.Body className="bg-light">
        <p class="text-center">This will remove any existing groupings</p>
        <button className="btn btn-dark btn-block rounded-pill shadow-sm my-2" disabled={saving || creatingGroups} onClick={confirmationType == "Randomize" ? this.randomizeGroupings : this.standingsGroupings}>{confirmationType}</button>
    </Modal.Body>
  </Modal>
  </div>}</AppContext.Consumer>;

  }
}
